import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { ArticleClient } from 'api/clients/ArticleClient'
import Styles from 'components/Onboarding/RedirectModal/RedirectModal.module.scss'
import { ReactComponent as ArrowIcon } from 'components/DocRightRail/icons/ArrowSlim.svg'
import { ArticleCard, Props as ArticleCardProps } from 'common/ArticleCard/ArticleCard'
import { exitOnboarding } from 'components/OnboardingTooltip/OnboardingUtils'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

const ErrorMessage = 'Something went wrong while fetching the article you were reading, please refresh.'

interface Props {
  redirect_article_id: string
}

const RedirectModal = ({ redirect_article_id }: Props) => {
  const [redirectArticle, setRedirectArticle] = useState<ArticleCardProps['article']>()

  useEffect(() => {
    const getArticle = async () => {
      const {
        data: { article },
        type,
      } = await ArticleClient.getArticle(redirect_article_id)

      if (type === 'success') {
        setRedirectArticle(article)
      } else {
        showToastMessage(ErrorMessage, 'error')
      }
    }

    getArticle()
  }, [redirect_article_id])

  const renderContent = () => {
    if (!redirectArticle) return <div></div>

    return (
      <div className={Styles.container}>
        <div className={Styles.title}>Want to go back to the doc you were reading?</div>
        <Link to={redirectArticle.url} onClick={() => exitOnboarding('redirect_modal')}>
          <div className={Styles.linkUrl}>
            Take me back <ArrowIcon className={Styles.arrowIcon} />
          </div>
        </Link>
        <ArticleCard article={redirectArticle} className={Styles.articleCard} showStats={false} />
      </div>
    )
  }

  return renderContent()
}

export default RedirectModal
